import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { Card, Button, Icon } from "antd";
import { useFreire } from "../../utils/freireContext";
import * as texts from "./locales";
import { appEnv } from "../../appEnv";

const CPMS_URL = appEnv.REACT_APP_CPMS_URL;

const OnboardingComplete = ({ history, location }) => {
  const { freire } = useFreire();

  const query = useMemo(() => new URLSearchParams(location.search), [
    location.search,
  ]);
  const returnTo = query.get("returnTo");

  const handleBack = () => {
    if (returnTo === "cpms" && CPMS_URL) {
      globalThis.location.href = CPMS_URL;
      return;
    }
    history.push("/");
  };

  const buttonLabel =
    returnTo === "cpms" ? freire(texts.BACK_TO_CPMS) : freire(texts.BACK_TO_LOGIN);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: "#f0f2f5",
        padding: 16,
      }}
    >
      <Card style={{ width: "100%", maxWidth: 480, textAlign: "center" }}>
        <Icon
          type="check-circle"
          theme="twoTone"
          twoToneColor="#52c41a"
          style={{ fontSize: 56, marginBottom: 16 }}
        />
        <h2>{freire(texts.TITLE)}</h2>
        <p style={{ marginBottom: 24 }}>{freire(texts.DESCRIPTION)}</p>
        <Button
          type="primary"
          size="large"
          onClick={handleBack}
          style={{ backgroundColor: "#001529" }}
        >
          {buttonLabel}
        </Button>
      </Card>
    </div>
  );
};

OnboardingComplete.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }).isRequired,
};

export default withRouter(OnboardingComplete);
